import CryptoJS from 'crypto-js';

// Helper function to format date as "yyyy-MM-dd HH:mm:ss"
const getFormattedDate = () => {
    const date = new Date();

    const pad = (num: any) => num.toString().padStart(2, '0');

    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

export const encryptGetClientDataRequest = (requestData: any) => {
    const aesKey = "MAJomsQlyfHjN5n/2KKhLhKBJv634EFR";
    const aesIV = "MAJomsQlyfG8XOpx";

    // 1️⃣ Convert request to JSON (RAW JSON)
    const jsonString = JSON.stringify(requestData);

    // 2️⃣ Base64 Encode JSON (ISO-8859-1)
    // Kotlin: toByteArray(Charset.forName("ISO-8859-1"))
    // JS: We parse as Latin1 (equivalent to ISO-8859-1) then stringify to Base64
    const encodedDetails = CryptoJS.enc.Base64.stringify(
        CryptoJS.enc.Latin1.parse(jsonString)
    );

    // 3️⃣ Generate HMAC-SHA256 hash on RAW JSON
    // Kotlin uses US_ASCII for key and data. Since key is alphanumeric, UTF8/Latin1 works same.
    const hashStr = CryptoJS.HmacSHA256(jsonString, aesKey).toString(CryptoJS.enc.Hex);

    // 4️⃣ Today's date
    const urlDate = getFormattedDate();

    // 5️⃣ Wrapper JSON
    // Note: JS objects are unordered by spec, but JSON.stringify preserves insertion order 
    // in most modern engines, which matches Map behavior often required by strict servers.
    const wrapperObj = {
        Encodedetails: encodedDetails,
        hashStr: hashStr,
        urldate: urlDate
    };
    const wrapperJson = JSON.stringify(wrapperObj);

    // 6️⃣ AES Encrypt wrapper JSON
    const keySpec = CryptoJS.enc.Utf8.parse(aesKey);
    const ivSpec = CryptoJS.enc.Utf8.parse(aesIV);

    const encrypted = CryptoJS.AES.encrypt(wrapperJson, keySpec, {
        iv: ivSpec,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7 // PKCS7 is compatible with PKCS5
    });

    // 7️⃣ Return Base64
    // CryptoJS encrypt return object .toString() creates Base64 by default
    return encrypted.toString();
};